import compact from "lodash/compact";
import Tooltip from "rc-tooltip";
import React from "react";
import Popover from "./popover";

export default function DropdownBtn({ items, ...props }) {
    return (
        <Popover {...props}>
            {compact(items).map(({ text, action, disabled, tooltipText, name }, index) =>
                disabled ? (
                    <Tooltip key={index} placement="right" overlay={tooltipText} overlayClassName="book-form__tooltip">
                        <div className="dropdown__item dropdown__item--disabled" onClick={action} data-test-id={name}>
                            {text}
                        </div>
                    </Tooltip>
                ) : (
                    <div key={index} className="dropdown__item" onClick={action} data-test-id={name}>
                        {text}
                    </div>
                ),
            )}
        </Popover>
    );
}
